export default "__VITE_ASSET__CRkFG2g9__"